/* eslint-disable no-console */
/* eslint-disable camelcase */
import { parseCookies } from 'nookies';

export const trackSponsoredEventNewtail = (url: string, products?: any) => {
  if (!url) return null;

  // Cookies lidos no momento do envio: o ajs_anonymous_id e o logged_id podem
  // mudar depois do load do módulo (login, Segment carregado tarde).
  const { ajs_anonymous_id, logged_id } = parseCookies();

  const jsonBlob = new Blob(
    [JSON.stringify({ session_id: ajs_anonymous_id, user_id: logged_id, ...products })],
    {
      type: 'application/json',
    }
  );

  return navigator.sendBeacon(url, jsonBlob);
};

export const trackSponsoredImpressionNewtail = hits => {
  const sponsoredUrl = hits.filter(hit => hit?.sponsoredData?.impression_url);

  if (!sponsoredUrl.length) return null;

  return sponsoredUrl.map(product => {
    return trackSponsoredEventNewtail(product.sponsoredData.impression_url, {
      sponsoredData: product.sponsoredData,
    });
  });
};

/**
 * Evento de "view" (viewability) do Madeira Ads: o anúncio ficou efetivamente
 * visível para o usuário. Diferente da impression, que indica apenas que o
 * anúncio foi renderizado. A plataforma usa o view na atribuição de ROAS e na
 * taxa de conversão padrão.
 */
export const trackSponsoredViewNewtail = product => {
  const viewUrl = product?.sponsoredData?.view_url;

  if (!viewUrl) return null;

  return trackSponsoredEventNewtail(viewUrl, {
    sponsoredData: product.sponsoredData,
  });
};

const trackSponsored = (data, type, products?: any) => {
  const trackTypes = {
    click: () => trackSponsoredEventNewtail(data?.sponsoredData?.click_url),
    impression: () => trackSponsoredImpressionNewtail(data),
    view: () => trackSponsoredViewNewtail(data),
    orderCompleted: () =>
      trackSponsoredEventNewtail(
        `${process.env.NEXT_PUBLIC_NEWTAIL_URL}/beacon/conversion`,
        products
      ),
  };

  return trackTypes[type]();
};

export default trackSponsored;
